// @ts-nocheck
import { buildActions, makeReqCons } from 'store/actions';
import type { ReduxFunction } from 'types/redux';

export const appConstants = {
  constants: makeReqCons('APP_CONSTANTS'),
  fetchAddress: makeReqCons('APP_FETCH_ADDRESS'),
  getViews: makeReqCons('GET_VIEWS'),
  updateViews: makeReqCons('UPDATE_VIEWS'),
  getFiltersName: makeReqCons('GET_FILTER_NAME'),
  getFilters: makeReqCons('GET_AVAILABLE_FILTERS'),
  customUrl: makeReqCons('CUSTOM_URL'),
  export: makeReqCons('INVOICE_EXPORT'),
};

type AppActions = {
  constants: Function;
  constantsRes: Function;
  fetchAddress: Function;
  fetchAddressRes: Function;
  getViews: ReduxFunction;
  getViewsRes: Function;
  updateViews: ReduxFunction;
  updateViewsRes: Function;
  getFiltersName: ReduxFunction;
  getFiltersNameRes: Function;
  getFilters: ReduxFunction;
  getFiltersRes: Function;
  customUrl: Function;
  customUrlRes: Function;
  export: ReduxFunction;
  exportRes: Function;
};

// Autogenerated actions according to constants
const appActions = buildActions<AppActions>('', appConstants, {});

export { appActions };
